import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/icon/icon_win.png';
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", null, [...(_cache[0] || (_cache[0] = [_createElementVNode("img", {
    src: _imports_0
  }, null, -1)]))]);
}